'use strict';

var novicell = novicell || {};

novicell.highlightedFeaturesOverlay = novicell.highlightedFeaturesOverlay || function () {
    
    function init() {
        var highlightedFeaturesButtons = document.querySelectorAll('.m-product-card__btn--openFeatureOverlay');
        if(highlightedFeaturesButtons.length){
            for(var i = 0 ; i< highlightedFeaturesButtons.length; i++){
                highlightedFeaturesButtons[i].addEventListener('click', function (e) {
                    e.preventDefault();
                    var featureOverlayId = this.getAttribute('data-feature-overlay-id');
                    if(featureOverlayId != null){
                        novicell.overlay.create({ 'selector': '#'+featureOverlayId, 'class':'novi-overlay--feature'});
                    }
                });
            }
        }
        
    }
    
    return {
        init: init
    };
    
}();
